import React, { Component } from 'react'
import { withStyles } from 'material-ui/styles'
import { withRouter } from 'react-router-dom'
import ReadingShare from '@/routes/alchemy/readingShare'
import { SHARED_USER_ID } from '@/constants'

const styles = theme => ({})

@withRouter
@withStyles(styles)
export default class AlchemySingleShare extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    global.localStorage.setItem(SHARED_USER_ID, this.props.match.params.id)

    return (
      <div>
        <ReadingShare trackerId={this.props.match.params.tracker} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/alchemy/singleShare.js